__turbopack_context__.v({
  "expandableCell": "expandableRow-module-scss-module__zsJ0wW__expandableCell",
  "expandableContentCell": "expandableRow-module-scss-module__zsJ0wW__expandableContentCell",
  "expandableRow": "expandableRow-module-scss-module__zsJ0wW__expandableRow",
  "expandableRowHeader": "expandableRow-module-scss-module__zsJ0wW__expandableRowHeader",
});
